module.exports = __webpack_public_path__ + "svg_80x80/springboot.bdf28d.svg";